import { forwardRef } from "react"
import { useCardLayoutContext } from "../../../../contexts/CardLayoutContext";
import { CardTileHeader } from "./CardTileHeader";
import { CardTileBody } from "./CardTileBody";
import { useDashboardDomainContext } from "../../../../DashboardDomainProvider";


export const CardTile = forwardRef(({ card, children, className, ...rest }, fRef) => {

    const {
        isBoxColliding,
    } = useCardLayoutContext();

    const {
        getVisualFromCard
    } = useDashboardDomainContext();

    const collisionClass = isBoxColliding(card) ? 'collision' : '';

    const visual = getVisualFromCard(card);

    return (
        <div
            ref={fRef}
            {...rest}
            key={card.i}
            className={`card-cell ${collisionClass} ${className} ${card?.x === 0 && card?.w === 1 ? 'first-column' : ''}`}
        >
            <div className={'inner'}>
                <CardTileHeader card={card} visual={visual} />
                <CardTileBody card={card} visual={visual} />
                {children}
            </div>
        </div>
    )
});